/* Personalized make/model FAQ (T650 proof) — mirrors the Equipment Fit tab:
   driven by the picker's `mmf:track-selected` event, the lead FAQ + the static
   answers update live to reflect the exact track the customer selected. */
(function(){
  var card = document.getElementById('pp-faq-dynamic');
  if(!card) return;
  // No picker on this page (~9% of make/model pages) → nothing to personalize; hide the dynamic
  // lead card so it never shows a misleading "select a track above" prompt. Static FAQs remain.
  if(!document.querySelector('.mmf-wrap')){ card.style.display = 'none'; return; }
  var qEl = document.getElementById('pp-faq-dyn-q');
  var aEl = document.getElementById('pp-faq-dyn-a');
  // Title-case the machine name ("BOBCAT T650" -> "Bobcat T650"); keep tokens with digits (model numbers) as-is.
  function tcaseMachine(s){ return String(s || '').trim().split(/\s+/).map(function(w){ return /\d/.test(w) ? w : (w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()); }).join(' '); }
  var raw = (card.getAttribute('data-machine') || '').trim();
  var machine = raw ? tcaseMachine(raw) : 'your machine';

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  // Normalize the default (pre-selection) copy to the nicer casing.
  if(raw && qEl) qEl.textContent = 'Will the track you choose fit your ' + machine + '?';
  if(raw && aEl) aEl.textContent = "Select a tread and size above — we'll confirm the exact track you picked fits your " + machine + ".";

  // Highlight the selected size wherever it appears in the static FAQ answers
  // (answers use "320x86x52"; the picker reports "320×86×52" — match either separator).
  function highlightSize(size){
    var body = size.replace(/[x×]/gi, '[x×]').replace(/[.*+?^${}()|[\]\\]/g, function(m){ return m === 'x' || m === '×' ? m : '\\' + m; });
    var re;
    try { re = new RegExp(size.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/[x×]/gi, '[x×]'), 'i'); }
    catch(e){ return; }
    document.querySelectorAll('#pp-tab-faqs .pp-faq-item:not(.pp-faq-dynamic) .pp-faq-a').forEach(function(a){
      if(a.getAttribute('data-orig') == null) a.setAttribute('data-orig', a.innerHTML);
      var html = a.getAttribute('data-orig');
      a.innerHTML = html.replace(re, function(m){ return '<mark class="pp-faq-mark">' + m + '</mark>'; });
    });
  }

  function personalize(d){
    var size = d && d.size ? String(d.size).trim() : '';
    var tread = d && d.tread ? String(d.tread).trim() : '';
    if(!size) return;
    var label = size + (tread ? ' · ' + tread : '');
    qEl.textContent = 'Does the ' + label + ' track fit my ' + machine + '?';
    aEl.innerHTML = 'Yes — the <strong>' + esc(size) + (tread ? ' ' + esc(tread) : '') +
      '</strong> track you selected is verified to fit your <strong>' + esc(machine) +
      '</strong>. Every track is checked against factory make, model, and year data before it ships. ' +
      'Enter your serial number at checkout for instant confirmation, or call ' +
      '<a href="tel:8665168473">(866) 516-8473</a> and a track expert will confirm it for you.';
    card.open = true;
    highlightSize(size);
  }

  document.addEventListener('mmf:track-selected', function(e){ personalize(e.detail || {}); });
  // Pick up a selection the picker resolved before this deferred script loaded (single-track pages).
  if(window.__mmfSelected) personalize(window.__mmfSelected);
})();
